module.exports = __webpack_public_path__ + "img/default_cn.4fbe18f.jpg";